import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { exchangeCodeForToken, restoreLocalStorageBackupIfSameUser } from "./auth";
import { useDispatch } from "react-redux";
import { setAuth } from "../authSlice";
import AppLoader from "../../../assets/images/appLoader.gif";

const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const code = searchParams.get("code");
        if (code) {
            exchangeCodeForToken(code).then((data) => {
                if (data?.token) {
                    const authData = {
                        accessToken: data?.token?.accessToken,
                        refreshToken: data?.token?.refreshToken,
                        expiresIn: Date.now() + data?.token?.expiresIn,
                        cognitoId: data?.account?.cognitoId,
                        email: data?.account?.email,
                        userId: data?.account?.id,
                        firstName: data?.account?.firstName || '',
                        lastName: data?.account?.lastName || '',
                        company: {
                            name: data?.account?.company?.name,
                            companyEmail: data?.account?.company?.companyEmail,
                        },
                    }
                    // localStorage.setItem("authData", JSON.stringify(authData));
                    dispatch(setAuth(authData));
                    restoreLocalStorageBackupIfSameUser(authData.userId);
                    navigate("/home");
                }
            });
        }
    }, []);

    return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={AppLoader} alt="Loading website definition" width={130} />
    </div>;
};

export default AuthCallback;
